import { render, staticRenderFns } from "./AnalysisDetail.vue?vue&type=template&id=08c89810&"
import script from "./AnalysisDetail.vue?vue&type=script&lang=js&"
export * from "./AnalysisDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports